import React, { createContext, useCallback, useContext, useState } from "react";

type SidebarLockContextType = {
  locked: boolean;
  lock: () => void;
  unlock: () => void;
};

const SidebarLockContext = createContext<SidebarLockContextType>({
  locked: false,
  lock: () => {},
  unlock: () => {}
});

export function SidebarLockProvider({ children }: { children: React.ReactNode }) {
  const [locked, setLocked] = useState(false);
  const lock = useCallback(() => setLocked(true), []);
  const unlock = useCallback(() => setLocked(false), []);

  return (
    <SidebarLockContext.Provider value={{ locked, lock, unlock }}>
      {children}
    </SidebarLockContext.Provider>
  );
}

export function useSidebarLock() {
  return useContext(SidebarLockContext);
}
